import { createSlice } from '@reduxjs/toolkit'
import { Slice, CheckResetPasswordTokenDeps } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false
}

const slice = createSlice({
  name: 'customer/checkResetPasswordToken',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function checkResetPasswordToken (payload: CheckResetPasswordTokenDeps): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())

    try {
      const { token } = payload
      const response = await magentoClient.getClient().customer.checkResetPasswordToken({
        token
      })
      const { data } = response
      const { validateResetPasswordLinkToken } = data || {}
      if (validateResetPasswordLinkToken) {
        dispatch(success())
      } else {
        dispatch(failure())
      }

      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
